import Layout from "../Layout/Layout";
import { StyledCareer } from "./Career.Styled";
import heroImage from "../../assets/image/career/hero.jpg";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import History from "./History/History";
import Boxes from "./Boxes/Boxes";
import Reasons from "./Reasons/Reasons";
import Banner from "./Banner/Banner";
import People from "./People/People";
import OpenPositions from "./OpenPositions/OpenPositions";
import Separator from "./Separator/Separator";
import Hero from "../SubComponents/Hero/Hero";
import Seo from "../Layout/Seo/Seo";

const Career = () => {
  const translation = useSelector((s) => s[props.TRANSLATION]);

  return (
    <Layout authRequired={false}>
      <Seo
        title="Bayka Berlin GmbH"
        description="Bayka Berlin GmbH - der Berliner Fertigungsstandort der Bayerische Kabelwerke AG für Starkstromkabel. Erfahre warum es sich lohnt, ein Teil des Teams zu werden."
      />
      <StyledCareer>
        <Hero
          title={translation.career.title}
          by={translation.career.by}
          bg={heroImage}
          top
        />
        <Boxes />
        <History />
        <Separator />
        <Reasons />
        <Banner />
        <People />
        <OpenPositions />
      </StyledCareer>
    </Layout>
  );
};

export default Career;
